import {DirectionType} from '../enum/DirectionType';


export class Order{
  constructor(attribute: string = 'id', direction: DirectionType = DirectionType.asc) {
    this.attribute = attribute;
    this.direction = direction;
  }
    attribute: string;
    direction: DirectionType;
}
